import { connect } from 'react-redux';
import { isUserLoggedIn } from 'apps/user/helpers';
import { setNickname } from 'apps/user/actions/user';
import CreateReviewAddDetails from 'apps/products/components/reviews/CreateReviewAddDetails';

import {
  postReview,
  updateFields,
} from 'apps/products/actions/reviews';

export default connect(
  (state, ownProps) => {
    const { sku } = ownProps;
    return {
      sku,
      isLoggedIn: isUserLoggedIn(state.user),
      rating: state.reviews.addReview.rating,
      recommended: state.reviews.addReview.recommended,
      newNickname: state.reviews.addReview.newNickname,
      reviewTitle: state.reviews.addReview.reviewTitle,
      reviewText: state.reviews.addReview.reviewText,
      validationErrors: state.reviews.addReview.validationErrors,
    };
  },
  {
    postReview,
    updateFields,
    setNickname,
  }
)(CreateReviewAddDetails);
